/* eslint-disable no-case-declarations */
import actionTypes from '../actions/reduxActions/actionTypes';
import { assocPath, reject, propEq, append, pipe, pathOr } from 'ramda';

export const updateMapElement = (mapElement, state) => pipe(
    reject(
        // remove current matching element
        propEq('id', mapElement.id),
    ),
    // replace with / add new map element
    append(mapElement),
)(state);

export const updateMapElementSubflowId = ({ elements, mapElement, subflowId }) => {
    const subflowPath = subflowId ? ['subflow', 'flowId', 'id'] : ['subflow'];
    const updatedMapElement = assocPath(subflowPath, subflowId, mapElement);
    return updateMapElement(updatedMapElement, elements);
};

export const updateMapElementDeveloperName = ({ elements, mapElement, developerName }) => {
    const updatedMapElement = assocPath(['developerName'], developerName, mapElement);
    return updateMapElement(updatedMapElement, elements);
};

export const moveMapElement = ({ mapElementId, x, y }, mapElements) => {
    const updatedMapElements = mapElements.map((mapElement) => {
        if (mapElement.id === mapElementId) {
            return {
                ...mapElement,
                x,
                y,
            };
        }
        return mapElement;
    });

    return updatedMapElements;
};

export const removeOutcome = ({ type, mapElement }) => {
    const outcomes = mapElement.outcomes ? mapElement.outcomes.filter(outcome => outcome.id !== type) : mapElement.outcomes;
    return { ...mapElement, outcomes };
};

export const findAndRemoveOutcome = ({ type, mapElementId }, mapElements) => {
    const mapElement = mapElements.find(el => el.id === mapElementId);
    return removeOutcome({ type, mapElement });
};

export const createOutcomeToXY = ({ type, fromMapElementId, toXY }, mapElements) => {
    const mapElement = findAndRemoveOutcome({ type, mapElementId: fromMapElementId }, mapElements);
    const outcomes = pathOr([], ['outcomes'], mapElement);
    outcomes.push({
        id: type,
        next: {
            x: toXY.x,
            y: toXY.y,
        },
    });
    return updateMapElement({ ...mapElement, outcomes }, mapElements);
};

export const createOutcomeToMapElement = ({ type, fromMapElementId, toMapElementId }, mapElements) => {
    const mapElement = findAndRemoveOutcome({ type, mapElementId: fromMapElementId }, mapElements);
    const outcomes = pathOr([], ['outcomes'], mapElement);
    outcomes.push({
        id: type,
        nextMapElementId: toMapElementId,
    });
    return updateMapElement({ ...mapElement, outcomes }, mapElements);
};

export const removeAllOutcomesOfType = ({ type }, mapElements) => mapElements.map(mapElement => removeOutcome({ type, mapElement }));

const mapElements = (elements = [], { type, payload }) => {

    switch (type) {

    case actionTypes.MAP_ELEMENT_SET:
    case actionTypes.NOTE_UPDATE:
        return updateMapElement(payload, elements);
            
    case actionTypes.NOTE_ADD:
        return updateMapElement(payload.note, elements);

    case actionTypes.MAP_ELEMENT_SET_ALL:
        return payload;

    case actionTypes.MAP_ELEMENT_SET_DEVELOPER_NAME:
        return updateMapElementDeveloperName({ elements, ...payload });

    case actionTypes.MAP_ELEMENT_SET_SUBFLOW_ID:
        return updateMapElementSubflowId({ elements, ...payload });

    case actionTypes.MAP_ELEMENT_REMOVE:
        return elements.filter(mapElement => mapElement.id !== payload);

    case actionTypes.MAP_ELEMENT_MOVE:
        return moveMapElement(payload, elements);

    case actionTypes.MAP_ELEMENT_CREATE_FAKE_OUTCOME_TO_XY:
        return createOutcomeToXY({ ...payload }, elements);

    case actionTypes.MAP_ELEMENT_CREATE_FAKE_OUTCOME_TO_MAP_ELEMENT:
        return createOutcomeToMapElement({ ...payload }, elements);

    case actionTypes.MAP_ELEMENT_REMOVE_OUTCOME:
        return updateMapElement(findAndRemoveOutcome({ ...payload }, elements), elements);

    case actionTypes.MAP_ELEMENT_REMOVE_ALL_OUTCOME:
        return removeAllOutcomesOfType({ ...payload }, elements);

    default:
        return elements;
    }
};

export default mapElements;
